/* unplugin-vue-components disabled */import { render } from "./CommunitySettingView.vue?vue&type=template&id=d9d210d0&scoped=true"
import script from "./CommunitySettingView.vue?vue&type=script&lang=js"
export * from "./CommunitySettingView.vue?vue&type=script&lang=js"

import "./CommunitySettingView.vue?vue&type=style&index=0&id=d9d210d0&lang=scss&scoped=true"

import exportComponent from "/root/workspace/xhzj-pc_Z77T/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9d210d0"]])

export default __exports__